/**
 * The CarbonWeb mark.
 *
 * A component rather than an `<img>` to an SVG file, for two reasons. It
 * inherits the size it is given without a second network request on a screen
 * whose whole job is to load fast, and the gradient id has to be unique on the
 * page — an imported file used twice would produce two identical ids, and in
 * some browsers the second element paints with the first one's gradient.
 */
export function CarbonMark({ className }: { readonly className?: string }) {
  return (
    <svg
      viewBox="0 0 35 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      // Decorative: the product name sits beside it as real text, so a screen
      // reader announcing "Carbon Mail" twice would be worse than silence.
      aria-hidden="true"
      focusable="false"
    >
      <title>Carbon Mail</title>
      <defs>
        <linearGradient id="carbon-mark-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00B0C2" />
          <stop offset="100%" stopColor="#69D757" />
        </linearGradient>
      </defs>
      <path
        d="M 26.365 17.326 L 26.365 22.851 L 13.169 30.468 L 4.157 25.265 L 4.157 25.211 L 4.157 20.437 L 4.157 10.031 L 13.169 4.828 L 22.207 10.031 L 22.207 5.257 L 22.207 5.203 L 13.169 0 L 0 7.617 L 0 22.851 L 0 27.706 L 4.13 30.12 L 13.169 35.35 L 30.602 25.292 L 30.602 17.326 L 26.365 17.326 Z"
        fill="url(#carbon-mark-gradient)"
        fillRule="nonzero"
      />
    </svg>
  )
}
